import { Error as PepperError } from 'modules/cm/pages/CaseDetailsPage/Pepper/store';

class PepperSendError extends Error {
  private errors: string[];

  constructor(errors: PepperError[]) {
    super('Pepper Sending Error');

    this.errors = errors;

    Object.setPrototypeOf(this, PepperSendError.prototype);
  }

  getErrors() {
    return this.errors;
  }
}

export default PepperSendError;
